import { PDF_CONTENT_TYPE } from "@contract-manager/shared";
import type { MessageKey } from "../i18n/messages";

/**
 * What the browser can tell about a file before spending an upload on it.
 *
 * The API signs the presigned PUT for `application/pdf` exactly, so a .docx
 * picked by mistake fails at S3 with an opaque 403 minutes later. Catching it
 * here costs nothing and says something a staffer can act on.
 *
 * There is deliberately no size check: no upper bound is configured on the
 * API (`MAX_UPLOAD_BYTES` is unset), and inventing a different number here
 * would reject files the server would have taken.
 */
export function validatePdfFile(file: {
  name: string;
  type: string;
}): MessageKey | null {
  // Some browsers report an empty type for a file dragged from an archive or
  // a network share. Fall back to the extension rather than refusing outright.
  const claimedType = file.type.trim();
  const looksPdf =
    claimedType === PDF_CONTENT_TYPE ||
    (claimedType === "" && file.name.toLowerCase().endsWith(".pdf"));

  return looksPdf ? null : "contracts.upload.notPdf";
}
